import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface ExamSearchProps {
	searchTerm: string;
	onSearchChange: (value: string) => void;
}

export function ExamSearch({ searchTerm, onSearchChange }: ExamSearchProps) {
	return (
		<div className="relative mx-auto w-full max-w-xl">
			<Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
			<Input
				type="text"
				placeholder="Buscar exames por nome, preparo ou descrição..."
				value={searchTerm}
				onChange={(e) => onSearchChange(e.target.value)}
				className="h-11 rounded-xl border-zinc-300 bg-white pl-10 pr-4"
			/>
		</div>
	);
}
